/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_AssetsInputs */

const en_total_assets = /** @type {(inputs: Total_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Assets`)
};

const es_total_assets = /** @type {(inputs: Total_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activos totales`)
};

const fr_total_assets = /** @type {(inputs: Total_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biens totaux`)
};

const de_total_assets = /** @type {(inputs: Total_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamte Assets`)
};

const ja_total_assets = /** @type {(inputs: Total_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総アセット数`)
};

const zh_total_assets = /** @type {(inputs: Total_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总资产`)
};

const ar_total_assets = /** @type {(inputs: Total_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي الأصول`)
};

const id_total_assets = /** @type {(inputs: Total_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Aset`)
};

const it_total_assets = /** @type {(inputs: Total_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risorse Totali`)
};

const ru_total_assets = /** @type {(inputs: Total_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего активов`)
};

const pt_total_assets = /** @type {(inputs: Total_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de Ativos`)
};

const ko_total_assets = /** @type {(inputs: Total_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 에셋 수`)
};

/**
* | output |
* | --- |
* | "Total Assets" |
*
* @param {Total_AssetsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const total_assets = /** @type {((inputs?: Total_AssetsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_AssetsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_total_assets(inputs)
	if (locale === "es") return es_total_assets(inputs)
	if (locale === "fr") return fr_total_assets(inputs)
	if (locale === "de") return de_total_assets(inputs)
	if (locale === "ja") return ja_total_assets(inputs)
	if (locale === "zh") return zh_total_assets(inputs)
	if (locale === "ar") return ar_total_assets(inputs)
	if (locale === "id") return id_total_assets(inputs)
	if (locale === "it") return it_total_assets(inputs)
	if (locale === "ru") return ru_total_assets(inputs)
	if (locale === "pt") return pt_total_assets(inputs)
	return ko_total_assets(inputs)
});